//Which Hopper is this?
//
//Chrome offers a drone's full advertised name ("Hopper_00004233") exactly once,
//the first time it is paired. Every connection after that it serves a cached
//GAP name, plain "Hopper". So the serial has one moment where it can be caught,
//and if it is dropped or overwritten it is gone for that browser for good.
//
//That single point of failure is why this file exists. The serial is written to
//two places that do not fail together: the per-device key the app has always
//used, and one fleet record holding every Hopper this browser has ever seen.
//Neither is ever downgraded. A blank read never overwrites a good one.

const FLEET_KEY = 'ftw_fleet_v1';

function readFleet() {
  try {
    let raw = localStorage.getItem(FLEET_KEY);
    let parsed = raw ? JSON.parse(raw) : {};
    return (parsed && typeof parsed === 'object') ? parsed : {};
  } catch(e) {
    //Corrupt or blocked storage. Start clean rather than taking the app down.
    return {};
  }
}

function writeFleet(fleet) {
  try {
    localStorage.setItem(FLEET_KEY, JSON.stringify(fleet));
  } catch(e) {
    //Storage full or blocked. The per-device key is the other copy.
  }
}

//Pull the serial out of an advertised name. "Hopper_00004233" -> "00004233",
//and the older "HOPPER #1234" form the app used to write -> "1234".
export function serialFromName(name) {
  if(!name) return '';
  let m = String(name).trim().match(/[_#-]\s*([A-Za-z0-9]{3,})$/);
  return m ? m[1] : '';
}

//Everything known about one drone, from whichever copy still has it.
export function recallDrone(deviceId) {
  let record = readFleet()[deviceId] || {};
  let serial = record.serial || '';
  let name = record.name || '';
  if(!serial) {
    //Fall back to the per-device keys, including ones written before the
    //fleet record existed.
    try {
      serial = localStorage.getItem('hopper_' + deviceId + '_serial') || '';
      name = name || localStorage.getItem('hopper_' + deviceId) || '';
      if(!serial) serial = serialFromName(name);
    } catch(e) {
      //Nothing recoverable. The caller falls back to a GATT read.
    }
  }
  return { serial: serial, name: name, firmware: record.firmware || '' };
}

//Upgrade only. A connection that learned nothing new leaves the record alone.
export function rememberDrone(deviceId, info) {
  if(!deviceId) return;
  info = info || {};
  let fleet = readFleet();
  let record = fleet[deviceId] || {};

  if(info.serial && !record.serial) record.serial = info.serial;
  if(info.name && (!record.name || serialFromName(info.name))) record.name = info.name;
  if(info.firmware && info.firmware !== 'unknown') record.firmware = info.firmware;
  if(!record.firstSeen) record.firstSeen = new Date().toISOString();
  record.lastSeen = new Date().toISOString();

  fleet[deviceId] = record;
  writeFleet(fleet);

  //Keep the per-device keys in step so the two copies stay independent.
  try {
    if(record.serial) localStorage.setItem('hopper_' + deviceId + '_serial', record.serial);
    if(record.name) localStorage.setItem('hopper_' + deviceId, record.name);
  } catch(e) {
    //Fleet record still holds it.
  }
}
